import { useEffect } from 'react';

import { useStreamClient } from '../session/StreamProvider.js';
import { clearLiveClient, installLiveClient } from './source.js';

/**
 * Installs the connected Stream client into the data seam while mounted, and
 * tears it down on unmount — so the inbox/conversation read live channels while
 * a view (or the open widget panel) is connected, and fall back to fixtures
 * otherwise. Renders nothing; it only bridges the Stream context to the seam.
 *
 * `preload` loads every channel up front, and NOBODY passes it any more: the
 * widget's list moved to the read model (as /chat's already was), so both
 * surfaces select through the query and hydrate per conversation. The option
 * survives only because the live seam's tests drive it; it is a candidate for
 * deletion, not for a second caller.
 */
export function LiveDataBridge({ preload = false }: { preload?: boolean }) {
  const { client } = useStreamClient();

  useEffect(() => {
    if (!client) return;
    void installLiveClient(client, { preload });
    return () => clearLiveClient();
  }, [client, preload]);

  return null;
}
